// Card #1640 (design §8.2/§8.3) — a theme's logo slots each carry a size
// key (small/medium/large); this is the one place that maps those labels to
// a concrete height, shared by the theme editor's config page (§8.3, picker
// + live preview) and the actual board (ScoreboardFrame, §8.4 application).
//
// Card #2498 AC1/AC2 — this used to be vh-based (4/7/11vh) so the board
// scaled consistently from a small kiosk monitor up to a big arena TV with
// no fixed design size. It now renders inside the fixed 1920x1080 design
// canvas (ScoreboardFrame.jsx's `.scoreboard-frame__logo`), so the same
// "scales consistently" goal is met by the canvas's own uniform
// transform:scale() instead — a vh value applied INSIDE that scaled canvas
// would resolve against the real viewport and then get scaled a second
// time (the card's own "wrong twice over" warning), so these are now the
// mechanical vh->px conversion at the 1920x1080 design size (1vh =
// 10.8px), same as every other value in this directory: 4vh -> 43.2px,
// 7vh -> 75.6px, 11vh -> 118.8px.
export const LOGO_SIZES = ["small", "medium", "large"];

export const DEFAULT_LOGO_SIZE = "medium";

export const LOGO_SIZE_HEIGHT_PX = {
  small: 43.2,
  medium: 75.6,
  large: 118.8,
};

export const LOGO_SIZE_LABELS = {
  small: "Small",
  medium: "Medium",
  large: "Large",
};

// Unrecognized/absent size keys fall back to the default height rather than
// rendering unsized (which, per ScoreboardFrame's current object-fit:
// contain + no explicit height, would just show the image at its raw pixel
// size — unpredictable across upload resolutions).
export function logoHeightPx(size) {
  return LOGO_SIZE_HEIGHT_PX[size] ?? LOGO_SIZE_HEIGHT_PX[DEFAULT_LOGO_SIZE];
}
